<template>
  <div class="container-flow">
    <div class="navbar fixed-top">
      <b-navbar-brand>
        <img
          src="https://qa-qosa.pearsonclinical.com/qosa-a2/assets/img/pearson-logo.svg"
          width="100"
        />
      </b-navbar-brand>
    </div>
    <div class="container-fluid">
      <div>
        <b-tabs>
          <b-tab title="Microservices" active>
            <QgApplication />
          </b-tab>
          <b-tab title="Qscoring Bundles">
            <QscoringBundles />
          </b-tab>
          <b-tab title="Reporting Bundles">
            <ReportingBundles />
          </b-tab>
          <b-tab title="Lacrosse Bundles">
            <LacrosseBundles />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import QgApplication from "./QgApplication.vue";
import QscoringBundles from "./QscoringBundles.vue";
import ReportingBundles from "./ReportingBundles.vue";
import LacrosseBundles from "./LacrosseBundles.vue";
export default {
  name: "QgDashboard",
  components: {
    LacrosseBundles,
    QgApplication,
    QscoringBundles,
    ReportingBundles,
  }
};
</script>
<style scoped>
.navbar {
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  background-color: #fff;
}

.container-fluid {
  padding: 70px 60px 0 60px;
}
.container-flow{
  width: fit-content;
}
</style>
